// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1jN9L","content":"LayoutSettings_content__2GSJm"};